import { EntityManager } from "@/components/EntityManager";
import { STATES, EIA_REGIONS, YES_NO, LOAD_LENGTH, LOAD_WEIGHT } from "@/constants/options";

const money = (v) => (v === null || v === undefined || v === "" ? <span className="text-neutral-300">—</span> : `$${Number(v).toLocaleString()}`);

export default function TripLog() {
  const columns = [
    { key: "date", label: "Date", render: (r) => r.date ? String(r.date).slice(0, 10) : "—" },
    { key: "driver", label: "Driver" },
    { key: "vehicle_number", label: "Unit" },
    { key: "origin", label: "Origin" },
    { key: "destination", label: "Destination" },
    { key: "distance_miles", label: "Miles", align: "right" },
    { key: "rate_per_mile", label: "Rate/Mi", align: "right", render: (r) => money(r.rate_per_mile) },
    { key: "total_cost", label: "Total", align: "right", render: (r) => money(r.total_cost) },
    { key: "work_order_number", label: "WO" },
    { key: "complete", label: "Done" },
  ];
  const fields = [
    { label: "Date", field: "date", type: "date" },
    { label: "Driver", field: "driver" },
    { label: "Vehicle Type", field: "vehicle_type" },
    { label: "Vehicle Number", field: "vehicle_number" },
    { label: "Avg. Diesel Cost", field: "avg_diesel_cost", type: "number" },
    { label: "Origin", field: "origin" },
    { label: "Destination", field: "destination" },
    { label: "Distance (Miles)", field: "distance_miles", type: "number" },
    { label: "Rate per Mile", field: "rate_per_mile", type: "number" },
    { label: "Total Cost", field: "total_cost", type: "number" },
    { label: "Origin State", field: "origin_state", type: "select", options: STATES },
    { label: "EIA Diesel Region", field: "eia_diesel_region", type: "select", options: EIA_REGIONS },
    { label: "Load Length", field: "load_length", type: "select", options: LOAD_LENGTH },
    { label: "Load Weight", field: "load_weight", type: "select", options: LOAD_WEIGHT },
    { label: "Est. Time of Haul (hrs)", field: "est_time_hrs", type: "number" },
    { label: "Project Number", field: "project_number" },
    { label: "Work Order Number", field: "work_order_number" },
    { label: "Booked", field: "booked", type: "select", options: YES_NO },
    { label: "Complete", field: "complete", type: "select", options: YES_NO },
  ];
  return <EntityManager collection="trips" title="Trip Log" subtitle="Completed & booked haul records with cost tracking" columns={columns} fields={fields} />;
}
